import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Badge } from '../atoms';

export const MessageListBoxContainer = styled(Link)`
  display: flex;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);
  width: 85%;
  height: min-content;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 10px 0;
  text-decoration: none;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    border-radius: 0;
    width: 100%;
  }
`;
export const Info = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
  width: calc(100% - 40px);
`;
export const InfoRow = styled(Info)`
  flex-direction: row;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
`;
export const ColumnGrow = styled(Column)`
  flex-grow: 2;
`;
export const Row = styled(Column)`
  flex-direction: row;
`;
export const Centre = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height:100%
  align-items: center;
  justify-content: center;
`;
export const BoldHeader = styled.p`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  ${(props) => props.theme.newTypography.textStyleBodySmallSemibold}
  margin: 0;
`;
export const RecentMessage = styled.div`
  padding-top: 12px;
`;
export const MessageAuthor = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmallSemibold}
`;
export const MessageContent = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  word-break: break-all;
`;
export const MessageInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
`;
export const CountContainer = styled.div`
  flex-grow: 2;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-shrink: 1;
  margin-bottom: 5px;
`;
export const Count = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.type.inverse};
  background: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.primary.default};
  ${(props) => props.theme.newTypography.textStyleBody}
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CaseManagerButton = styled(Link)`
  text-transform: uppercase;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.primary.default};
  border-radius: 8px;
  width: 100%;
  text-align: center;
  padding: 13px;
  font-size: 13px;
  box-sizing: border-box;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.type.inverse};
  border: none;
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-decoration: none;
  max-width: 350px;
  align-self: flex-end;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
    max-width: none;
  }
`;

export const LastMessageSent = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  margin: 0;
`;

export const MessageButton = styled(Button)`
  position: relative;
`;

export const MessageCountBadge = styled(Badge)`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 10px;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: default;
`;
